import {DEFAULT_AUTH_HOST} from './constants';
import {generateEnvDomain} from './generateEnvDomain';

let authApiHost = DEFAULT_AUTH_HOST;

authApiHost = generateEnvDomain(authApiHost);

if (process.env.REACT_APP_UNIONE_COMMONS_API_HOST) {
  authApiHost = process.env.REACT_APP_UNIONE_COMMONS_API_HOST;
}
const API = `${authApiHost}/api/v1`;

const isJSON = (response: Response) => {
  const contentType = response.headers.get('content-type');
  return contentType && contentType.indexOf('application/json') >= 0;
};

const request = (payload: RequestInfo | URL) => fetch(payload)
   .then((response) => {
     if (!response.ok) {
       // status beyond 200-299
       return Promise.reject(response);
     }

     return isJSON(response) ? response.json() : response.text();
   })
   .then((result) => result)
   .catch((error) => {
     const newErrorPayload = {
       error: true,
       status: error.status,
       message: error.statusText,
       url: error.url
     };

     if (isJSON(error)) {
       return error.json()
          .then((result: any) => {
            let errorMessage;

            if (result.ErrorMessage) {
              errorMessage = result.ErrorMessage;
            }

            if (result.error?.innererror?.message) {
              errorMessage = result.error.innererror.message;
            }

            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
              ...newErrorPayload,
              message: errorMessage
            });
          });
     }

     return Promise.reject(payload);
   });

const createRequest = (url: string, options: any, api?: string) => {
  let target;
  if (api) {
    target = api + url;
  } else {
    target = API + url;
  }
  const requestBody = new Request(target, options);
  return request(requestBody);
};

export const getRequest = (url: string, headers = {}, api?: string) => {
  const options = {method: 'GET', headers};
  return createRequest(url, options, api);
};

export const postRequest = (url: string, formData: any, headers = {}, api?: string) => {
  const options = {
    method: 'POST', body: formData, headers
  };
  return createRequest(url, options, api);
};

export const putRequest = (url: string, formData: any, headers = {}, api: string) => {
  const options = {method: 'PUT', body: formData, headers};
  return createRequest(url, options, api);
};

export const removeRequest = (url: string, headers = {}, api: string) => {
  const options = {method: 'DELETE', headers};
  return createRequest(url, options, api);
};
